import { TableRow as BaseTableRow, withStyles } from '@material-ui/core';

import { colors } from '../../styles';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const TableRow = withStyles({
  root: {
    height: '69px',
    '&:nth-of-type(even)': {
      backgroundColor: colors.custom.lightestGray50,
    },
    '&:hover': {
      backgroundColor: colors.custom.accessory,
    },
    '&:hover button': {
      opacity: 1,
    },
    '&$selected:nth-of-type(even)': {
      backgroundColor: colors.custom.lightestGray50,
    },
    '&$selected:nth-of-type(even):hover': {
      backgroundColor: colors.custom.accessory,
    },
    '&$selected:nth-of-type(odd)': {
      backgroundColor: 'inherit',
    },
    '&$selected:nth-of-type(odd):hover': {
      backgroundColor: colors.custom.accessory,
    },
  },
  head: {
    height: 60,
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  hover: {
    '&&&': {
      backgroundColor: colors.custom.accessory,
    },
  },
  selected: {},
})(BaseTableRow);
